class StartHero {
    constructor(root) {
        const video = root.querySelector('.start-hero__video');
        if (!video) return;

        const controlsWrapper =  root.querySelector('.start-hero__video-controls-wrapper');

        const markVideoReady = () => {
            controlsWrapper.classList.add('start-hero__video-controls-wrapper--ready');
            video.classList.add('start-hero__video--ready');
        };

        if (video.readyState >= 3) {
            markVideoReady();
        } else {
            video.addEventListener('canplay', markVideoReady);
        }

        const playPauseButton = root.querySelector('.start-hero__playPause');
        const playPauseIcon = root.querySelector('.start-hero__playPause i');

        if (!playPauseButton || !playPauseIcon) return;

        playPauseButton.addEventListener('click', () => {
            if (video.paused) {
                playPauseButton.classList.remove('start-hero__playPause--play');
                playPauseIcon.classList.replace('fa-play', 'fa-pause');
                video.play();
            } else {
                playPauseButton.classList.add('start-hero__playPause--play');
                playPauseIcon.classList.replace('fa-pause', 'fa-play');
                video.pause();
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const roots = document.querySelectorAll('.start-hero');
    roots.forEach(root => new StartHero(root));
});
